import React, { useState } from "react";
import "./ContentAnalytics.css";
import AnalyticsDropdownIcon from "../../assets/images/AnalyticsDropdownIcon.svg";
import { useRef, useEffect } from "react";
import Header from "../../Components/Header/Header";
import btn_insights from "../../assets/images/btn_insights.svg";
import { useNavigate } from "react-router-dom";
import { useUser } from "../../Context/UserContext";
import { callApi } from "../../utils/apiService";
import { videoCreatorEndPoint } from "../../Constants/constants";
import { formatDate } from "../../utils/helpers";
import PaginationLeft from "../../assets/images/pagination-left-arrow.svg";
import PaginationRight from "../../assets/images/pagination-right-arrow.svg";
import { showToast } from "../../utils/toastUtils";

const ContentAnalytics = () => {
  const [activeTab, setActiveTab] = useState("Videos");
  const navigate = useNavigate();
  const { user } = useUser();

  const ITEMS_PER_PAGE = 10;

  const [analyticsList, setAnalyticsList] = useState([]);
  const [analyticsStats, setAnalyticsStats] = useState(null);

  const [currentPage, setCurrentPage] = useState(1);
  const [totalItems, setTotalItems] = useState(0);
  const [totalPages, setTotalPages] = useState(0);

  const [loading, setLoading] = useState(false);



  // Mock data for Videos
  const videosData = {
    title: "Videos Analytics",
    summary: {
      totalContent: 25,
      totalViews: 4234,
      totalWatchTime: "56h 15m",
      subscriberGained: 12,
    },
    contentList: [
      {
        id: 1,
        title: "Mercury Retrograde Survival Guide",
        date: "21-1-26",
        views: 45,
        avgWatch: "58m",
        likes: 35,
        shares: 250,
        saveVideo: 2,
        type: "Video",
      },
      {
        id: 2,
        title: "Zodiac Compatibility: Leo",
        date: "18-1-26",
        views: 84,
        avgWatch: "1h",
        likes: 78,
        shares: 200,
        saveVideo: 11,
        type: "Video",
      },
      {
        id: 3,
        title: "Daily Tarot Reading",
        date: "17-1-26",
        views: 153,
        avgWatch: "20 min",
        likes: 132,
        shares: 300,
        saveVideo: 120,
        type: "Video",
      },
      {
        id: 4,
        title: "Astrology Forecast: February",
        date: "12-1-26",
        views: 613,
        avgWatch: "23 h",
        likes: 300,
        shares: 150,
        saveVideo: 60,
        type: "Video",
      },
      {
        id: 5,
        title: "Full Moon Rituals for Manifestation",
        date: "02-1-26",
        views: 76,
        avgWatch: "23 h",
        likes: 40,
        shares: 225,
        saveVideo: 90,
        type: "Video",
      },
    ],
  };

  // Mock data for Reels
  const reelsData = {
    title: "Reels Analytics",
    summary: {
      totalContent: 42,
      totalViews: 8567,
      totalWatchTime: "34h 20m",
      subscriberGained: 28,
    },
    contentList: [
      {
        id: 1,
        title: "Daily Horoscope - Aries",
        date: "20-1-26",
        views: 1234,
        avgWatch: "15 sec",
        likes: 456,
        shares: 678,
        saveVideo: 89,
        type: "Reel",
      },
      {
        id: 2,
        title: "Quick Tarot Prediction",
        date: "19-1-26",
        views: 987,
        avgWatch: "18 sec",
        likes: 345,
        shares: 456,
        saveVideo: 67,
        type: "Reel",
      },
      {
        id: 3,
        title: "Moon Phase Guide",
        date: "18-1-26",
        views: 2156,
        avgWatch: "20 sec",
        likes: 678,
        shares: 890,
        saveVideo: 123,
        type: "Reel",
      },
      {
        id: 4,
        title: "Lucky Numbers Today",
        date: "17-1-26",
        views: 1542,
        avgWatch: "12 sec",
        likes: 289,
        shares: 401,
        saveVideo: 56,
        type: "Reel",
      },
      {
        id: 5,
        title: "Astro Tips & Tricks",
        date: "16-1-26",
        views: 892,
        avgWatch: "16 sec",
        likes: 234,
        shares: 345,
        saveVideo: 42,
        type: "Reel",
      },
    ],
  };

  // Select data based on active tab
  const getActiveData = () => {
    switch (activeTab) {
      case "Videos":
        return videosData;
      case "Reels":
        return reelsData;
      default:
        return videosData;
    }
  };

  const activeData = getActiveData();
  const currentYear = new Date().getFullYear();

  const years = Array.from({ length: 6 }, (_, index) =>
    String(currentYear - 1 + index),
  );

  const monthOptions = [
    { label: "Jan", value: 1 },
    { label: "Feb", value: 2 },
    { label: "Mar", value: 3 },
    { label: "Apr", value: 4 },
    { label: "May", value: 5 },
    { label: "Jun", value: 6 },
    { label: "Jul", value: 7 },
    { label: "Aug", value: 8 },
    { label: "Sep", value: 9 },
    { label: "Oct", value: 10 },
    { label: "Nov", value: 11 },
    { label: "Dec", value: 12 },
  ];

  const [selectedMonth, setSelectedMonth] = useState(
    monthOptions[new Date().getMonth()]
  );

  const [selectedYear, setSelectedYear] = useState(
    String(new Date().getFullYear())
  );

  const [showMonthOptions, setShowMonthOptions] = useState(false);
  const [showYearOptions, setShowYearOptions] = useState(false);
  const monthRef = useRef(null);
  const yearRef = useRef(null);


  const fetchAnalyticsList = async () => {
    try {
      setLoading(true);

      const queryParams = new URLSearchParams({
        page: currentPage,
        limit: ITEMS_PER_PAGE,
        month: selectedMonth.value,
        year: selectedYear,
      });

      const endpoint =
        activeTab === "Videos"
          ? "video/analytics/list"
          : "reel/analytics/list";

      const response = await callApi(
        `${videoCreatorEndPoint}${endpoint}?${queryParams}`,
        "GET"
      );

      if (response?.status) {
        setAnalyticsList(
          activeTab === "Videos"
            ? response?.data?.videoAnalyticsList || []
            : response?.data?.reelAnalyticsList || []
        );

        setTotalItems(response?.data?.pagination?.totalItems || 0);
        setTotalPages(response?.data?.pagination?.pages || 0);
      }
    } catch (error) {
      console.error("Analytics List Error:", error);
      showToast(
        "error",
        error?.message || "Something went wrong while scheduling the post",
      );
    } finally {
      setLoading(false);
    }
  };


  const fetchAnalyticsStats = async () => {
    try {
      const queryParams = new URLSearchParams({
        month: selectedMonth.value,
        year: selectedYear,
      });

      const endpoint =
        activeTab === "Videos"
          ? "video/analytics/stats"
          : "reel/analytics/stats";

      const response = await callApi(
        `${videoCreatorEndPoint}${endpoint}?${queryParams}`,
        "GET"
      );

      if (response?.status) {
        setAnalyticsStats(response?.data);
      }
    } catch (error) {
      console.error("Analytics Stats Error:", error);
    }
  };

  useEffect(() => {
    setCurrentPage(1);
  }, [selectedMonth, selectedYear, activeTab]);



  useEffect(() => {
    const handleClickOutside = (e) => {
      if (monthRef.current && !monthRef.current.contains(e.target)) {
        setShowMonthOptions(false);
      }
      if (yearRef.current && !yearRef.current.contains(e.target)) {
        setShowYearOptions(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleInsightsClick = (item, activeTab) => {
    navigate("/video-insights", { state: { item, contentType: activeTab === "Videos" ? "Video" : activeTab === "Reels" ? "Reel" : "Story" } });
  };

  const Avatar = () => {
    if (user?.profileUrl) {
      return (
        <img
          src={user?.profileUrl}
          alt={user?.fullName}
          className="profile-avatar"
        />
      );
    }
    return (
      <div className="dash-profile-initials">
        {user?.fullName
          .split(" ")
          .map((n) => n[0])
          .slice(0, 1)
          .join("")}
      </div>
    );
  };

  const pageNumbers = Array.from(
    { length: totalPages },
    (_, index) => index + 1
  );

  const showingFrom =
    totalItems === 0
      ? 0
      : (currentPage - 1) * ITEMS_PER_PAGE + 1;

  const showingTo = Math.min(
    currentPage * ITEMS_PER_PAGE,
    totalItems
  );


  useEffect(() => {
    fetchAnalyticsList();
    fetchAnalyticsStats();
  }, [
    activeTab,
    currentPage,
    selectedMonth,
    selectedYear,
  ]);



  return (
    <>
      <Header />
      <div className="analytics-container">
        {/* Header Section */}
        <div className="analytics-header">
          <div className="header-profile-section">
            <div className="analytics-profile-avatar">
              <Avatar />
            </div>
            <div className="profile-info">
              <h1 className="analytics-profile-name">{user?.fullName}</h1>
              <p className="profile-handle">{user?.userName}</p>
            </div>
          </div>
        </div>

        {/* Tabs */}
        <div className="tabs-section">
          <div className="tabs-container">
            {["Videos", "Reels"].map((tabName) => (
              <button
                key={tabName}
                className={`tab-button ${activeTab === tabName ? "active" : ""}`}
                onClick={() => setActiveTab(tabName)}
              >
                {tabName}
              </button>
            ))}
          </div>
        </div>

        {/* Analytics Content */}
        <div className="analytics-content">
          {/* Title */}
          <div className="analytcs-month">
            <div>
              <h2 className="analytics-title">{activeData.title}</h2>
              <p className="analytics-description">
                Detailed performance insights for your {activeTab.toLowerCase()}
                .
              </p>
            </div>
            <div className="filter-section">
              <div className="custom-date-select" ref={monthRef}>
                <button
                  type="button"
                  className="custom-date-toggle"
                  onClick={() => setShowMonthOptions((s) => !s)}
                >
                  <div className="custom-date-lines">
                    <div className="date-main">{selectedMonth?.label}</div>
                    <div className="date-sub">Overall this month</div>
                  </div>
                  <img
                    src={AnalyticsDropdownIcon}
                    alt=""
                    className="analytics-dropdown-icon"
                  />
                </button>

                {showMonthOptions && (
                  <ul className="custom-date-options">
                    {monthOptions.map((m) => (
                      <li
                        key={m.value}
                        onClick={() => {
                          setSelectedMonth(m);
                          setShowMonthOptions(false);
                        }}
                      >
                        {m.label}
                      </li>
                    ))}
                  </ul>
                )}
              </div>
              <div className="custom-date-select" ref={yearRef}>
                <button
                  type="button"
                  className="custom-date-toggle"
                  onClick={() => setShowYearOptions((s) => !s)}
                >
                  <div className="custom-date-lines">
                    <div className="date-main">{selectedYear}</div>
                    <div className="date-sub">Overall this Year</div>
                  </div>
                  <img
                    src={AnalyticsDropdownIcon}
                    alt=""
                    className="analytics-dropdown-icon"
                  />
                </button>

                {showYearOptions && (
                  <ul className="custom-date-options">
                    {years.map((y) => (
                      <li
                        key={y}
                        onClick={() => {
                          setSelectedYear(y);
                          setShowYearOptions(false);
                        }}
                      >
                        {y}
                      </li>
                    ))}
                  </ul>
                )}
              </div>
            </div>
          </div>
          {/* Summary Cards */}
          <div className="summary-cards-grid">
            <div className="summary-card">
              <div className="card-label">Total {activeTab}</div>
              <div className="card-value">
                {activeTab === "Videos"
                  ? analyticsStats?.totalVideos || 0
                  : analyticsStats?.totalReels || 0}
              </div>
            </div>
            <div className="summary-card">
              <div className="card-label">Total Views</div>
              <div className="card-value">{analyticsStats?.totalViews || 0}</div>
            </div>
            <div className="summary-card">
              <div className="card-label">
                Total Watch time
                <br />
                (hours)
              </div>
              <div className="card-value">
                {analyticsStats?.totalWatchTimeHours || 0}
              </div>
            </div>
            <div className="summary-card">
              <div className="card-label">Subscriber Gained</div>
              <div className="card-value">
                {analyticsStats?.totalSubscribers || 0}
              </div>
            </div>
          </div>

          {/* Content List Table */}
          <div className="content-table-section">
            <h3 className="table-title">Content List</h3>
            <div className="table-wrapper">
              <table className="content-table">
                <thead>
                  <tr>
                    <th>{activeTab}</th>
                    <th>Date</th>
                    <th>Views</th>
                    <th>Avg Watch</th>
                    <th>Likes</th>
                    <th>Shares</th>
                    <th>Save {activeTab.slice(0, -1)}</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {analyticsList.map((item) => (
                    <tr key={item.videoId || item.reelId}>
                      <td className="content-title">{item.title}</td>
                      <td>
                        {formatDate(item.createdAt)}
                      </td>

                      <td>{item.totalViews}</td>
                      <td>{item.avgWatchTime}</td>
                      <td>{item.likesCount}</td>
                      <td>{item.sharesCount}</td>
                      <td>{item.saveCount}</td>
                      <td>
                        <button
                          className="action-button"
                          onClick={() => handleInsightsClick(item, activeTab)}
                        >
                          <img src={btn_insights} alt="btn_insights" />
                          <img src="" />
                          <span className="action-icon"></span>
                          Insights
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
              <div className="pagination-wrapper">
                <span>
                  Showing {showingFrom}-{showingTo}{" "}
                  from {totalItems} data
                </span>

                <div className="pagination-controls">

                  <img
                    src={PaginationLeft}
                    alt="prev"
                    onClick={() =>
                      currentPage > 1 &&
                      setCurrentPage((prev) => prev - 1)
                    }
                  />

                  {pageNumbers.map((page) => (
                    <button
                      key={page}
                      className={
                        currentPage === page
                          ? "active"
                          : ""
                      }
                      onClick={() =>
                        setCurrentPage(page)
                      }
                    >
                      {page}
                    </button>
                  ))}

                  <img
                    src={PaginationRight}
                    alt="next"
                    onClick={() =>
                      currentPage < totalPages &&
                      setCurrentPage((prev) => prev + 1)
                    }
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ContentAnalytics;
